export const accountInfoApiPath = {
  getAccountInfo: '/v2/accountInfo',
  createAccountInfo: '/v2/accountInfo',
  validateAccountInfo: '/v2/accountInfo/validate',
  getBanks: '/v2/accountInfo/banks',
} as const;
